// Directories that list OddsFantasy. Their reviewers check for these links
// (PolyMart ranks the review queue by them, PeerPush verifies the listing with
// one, Toolradar makes its link to us dofollow only while this one is followed,
// LaunchPoly, OpenHunts and ScrollLaunch require their badges), so they stay
// followed links and must not be removed while we're listed.
//
// LaunchPoly verifies its badge in the server-rendered homepage HTML: keep the
// data-launchpoly attribute, the plain <img> (not next/image) and its exact src.
const LAUNCHPOLY_BADGE_ID = "3u9bpFcjDKc2SPDEEGB0nW89scjkqgpf"

const FeaturedOn = ({ title }: { title: string }) => (
  <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3">
    <span className="font-semibold text-white">{title}</span>
    <a
      href="https://polymart.app"
      title="Polymarket Tools Directory"
      target="_blank"
      rel="noopener"
      className="font-medium ease-in duration-300 hover:text-white"
    >
      PolyMart
    </a>
    <a
      href="https://peerpush.com/p/oddsfantasy"
      title="OddsFantasy on PeerPush"
      target="_blank"
      rel="noopener"
      className="font-medium ease-in duration-300 hover:text-white"
    >
      PeerPush
    </a>
    <a
      href="https://toolradar.com/tools/oddsfantasy"
      title="OddsFantasy on Toolradar"
      target="_blank"
      rel="noopener"
      className="font-medium ease-in duration-300 hover:text-white"
    >
      Toolradar
    </a>
    <a
      href={`https://launchpoly.com/?ref=${LAUNCHPOLY_BADGE_ID}`}
      target="_blank"
      rel="noopener"
      data-launchpoly={LAUNCHPOLY_BADGE_ID}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`https://launchpoly.com/api/badges/claim/${LAUNCHPOLY_BADGE_ID}.svg?theme=dark&size=medium`}
        alt="Featured on LaunchPoly"
        width="150"
        height="44"
      />
    </a>
    {/* OpenHunts' free launch skips its queue while this badge is live. */}
    <a
      href="https://openhunts.com"
      target="_blank"
      rel="noopener"
      title="OpenHunts Club"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="https://cdn.openhunts.com/badges/club.webp"
        alt="OpenHunts Club Member"
        width="486"
        height="105"
        style={{ width: 195, height: "auto" }}
      />
    </a>
    {/* ScrollLaunch re-checks this link weekly; the listing's link to us is
        dofollow only while it's live. */}
    <a
      href="https://www.scrolllaunch.com/products/oddsfantasy?ref=badge"
      target="_blank"
      rel="noopener"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="https://www.scrolllaunch.com/api/badge/oddsfantasy"
        alt="Featured on ScrollLaunch"
        width="220"
        height="48"
        loading="lazy"
        style={{ width: 195, height: "auto" }}
      />
    </a>
  </div>
)

export default FeaturedOn
